<template>
  <div>
    <CardedSectionHeader
      icon="mdi-television"
      label="Account De-Activation Form"
      id="admin_diable_account_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="admin_disable_account_form_ref"
      id="admin_disable_account_form"
      title="_"
      :is_loading="is_loading || (parseInt(system_user_id) == 1) || system_user.status == 'deactivated'"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      submit_btn_color="warning"
      submit_btn_text="Disable"
      :show_clear_btn="false"
    >
      <v-alert
        dense
        text
        type="error"
        v-if="system_user.status == 'deactivated'"
      >
        This account has <strong>already been Disabled</strong>
      </v-alert>
      <v-alert
        dense
        text
        type="error"
        v-if="parseInt(system_user_id) == 1"
      >
        Please note that this <strong>Super Admin Account Cannot Be Disabled</strong>
      </v-alert>
      <div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">ID :</div>
          <b>#{{ system_user.id }}</b>
        </div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">First Name :</div>
          <b>{{ system_user.first_name }}</b>
        </div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">Last Name :</div>
          <b>{{ system_user.last_name }}</b>
        </div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">Username :</div>
          <b>{{ system_user.email }}</b>
        </div>
      </div>
      <v-row no-gutterss class="pa-0 mb-0 pt-5">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.username"
            :validation_rules="form_validations.username"
            label="Enter System Users Login Username exactly "
            icon="mdi-pen-plus"
            :disabled="is_loading || (parseInt(system_user_id) == 1)"
          ></TextField>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminUsersList",
  components: {
    CardedSectionHeader,
    CardedForm,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
    is_adding_admin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      system_user_id: 0,
      system_user: Utils.get_default_system_user(),
      errors: [],
      message: "",
      form: {
        username: "",
      },
      form_validations: {
        username: [
            Utils.validate.is_required("Users login username is required"),
            Utils.validate.email_format_or_phone(
                "Invalid input, must be a valid email address or a valid phone number"
            ),
        ],
      },
    };
  },
  methods: {
    load_system_user() {
      this.$emit("on-show-loader");
      ServerClient.Security.get_system_user(
        {
          id: this.system_user_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.system_user = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading system user on disable account ",
            errors
          );
        }
      );
    },
    submit() {
        //check if this is equal
        if(this.form.username != this.system_user.email){
            this.errors = ["The entered username is not correct"];
            this.$refs.admin_disable_account_form_ref.show_error_dialog();
            return false;
        }
        this.errors = [];
        this.message = "";
        this.$emit("on-show-loader");
        ServerClient.Security.disable_account({
            id: this.system_user_id
        },(res) => {
            this.$emit("on-hide-loader");
            this.message =
            "<b>Account has been disabled</b>";
            this.$refs.admin_disable_account_form_ref.show_message_dialog();
        },(errors) => {
            this.errors = errors;
            this.$refs.admin_disable_account_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
        });
    },
    on_auto_fill() {
        this.form.username = this.system_user.email;
        this.errors =[];
        this.message = "";
    },
    on_hide_message() {
        //reload form page
        this.$router.go(0);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.system_user_id = parseInt(this.$route.params.id);

    this.$emit("set-page-attributes", {
      title: "Disable System Users Account",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Users",
          disabled: false,
          href: "/admin/users",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/users/list",
        },
        {
          text: "Disable",
          disabled: true,
          href: "/admin/users/list/disable/" + this.system_user_id,
        },
      ],
    });
    this.load_system_user();
  },
};
</script>